import { OrderByField, VehicleCondition, VehicleStockStatus } from 'sales-types-common';
import { IStockFilterConfig } from '../../common';

export const stockListFilterKeys = [
  'brands',
  'modelIds',
  'colorIds',
  'interiorIds',
  'optionIdsIncluded',
  'applicationCodeList',
  'vehicleCondition',
  'locationIds',
  'modelSeries',
] as const;

export const rangeFilterKeyToTitle = {
  productionDate: 'Prod.dato',
  ttCode: 'TT',
  price: 'Pris',
} as const;

export const stockListDefaultFilters: IStockFilterConfig = {
  brands: [],
  modelSeries: [],
  modelIds: [],
  colorIds: [],
  interiorIds: [],
  optionIdsIncluded: [],
  locationIds: [],
  productionDate: { from: null, to: null },
  ttCode: { from: null, to: null },
  price: { from: null, to: null },
  searchText: '',
  status: [],
};

export const vehicleListDropToFilterKeyMap: Record<string, string> = {
  brands: 'brand',
  modelSeries: 'modelSeries',
  modelIds: 'modelId',
  colorIds: 'colorCode',
  interiorIds: 'interiorCode',
  optionIdsIncluded: 'options',
  locationIds: 'locationId',
};

export const dropdownToFilterKeyMap: Record<string, string> = {
  brands: 'brand',
  modelIds: 'modelId',
  colorIds: 'colorCode',
  interiorIds: 'interiorCode',
  optionIdsIncluded: 'options',
  applicationCodeList: 'applicationCode',
  vehicleCondition: 'vehicleCondition',
  locationIds: 'locationId',
  ttCode: 'trackTraceCodes',
  availabilityCodes: 'availabilityCodes',
};

export const vehicleListKeyToOrderFieldMap: Record<string, string> = {
  trackTraceCode: OrderByField.TRACKTRACECODE,
  pris: OrderByField.CAMPAIGNPRICE,
  productionDate: OrderByField.PRODUCTIONDATE,
};

export type StockListFilterKey = (typeof stockListFilterKeys)[number];
export type StockRangeFilterKey = keyof typeof rangeFilterKeyToTitle;

export const vehicleListStatus = [VehicleStockStatus.DEMO, VehicleStockStatus.FREE];
export const vehicleListCondition = [VehicleCondition.NEW];
export const Max_Items = 15;
